import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJob, updateJob } from "./employerJobAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobAsync = createAsyncThunk(
  "Job/fetch", 
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchJob(uuid);

      // const resp = data.response.data;
      const resp = data.response;
      // console.log("data.response Slice", resp)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateJobAsync = createAsyncThunk(
  "Job/update",
  async ({ uuid, jobData }, { rejectWithValue }) => {
    try {
      const response = await updateJob( uuid, jobData);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobSlice = createSlice({
  name: "Job",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchJobAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      
      .addCase(updateJobAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedCandidateIndex = state.data.findIndex(
            (jobData) => jobData.uuid === action.payload.uuid
          );
      
          if (updatedCandidateIndex !== -1) {
            state.data[updatedCandidateIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; // Fallback: set the state to an array with the updated 
        }
      })
      
      .addCase(updateJobAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update ";
      })
  },
});

export const selectJob = (state) => state.job.data;

export default JobSlice.reducer;
